import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import GlobalSearch from './GlobalSearch';
import NotificationBell from './NotificationBell';

export default function TopBar({ onMenuToggle }) {
  const { user, agency, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="topbar" role="banner">
      <div className="topbar-left">
        <button
          className="topbar-menu-btn"
          onClick={onMenuToggle}
          aria-label="Toggle navigation menu"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5H17M3 10H17M3 15H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
        {agency && (
          <div className="topbar-agency">
            {agency.logoUrl && (
              <img
                src={agency.logoUrl}
                alt={`${agency.name} logo`}
                className="topbar-agency-logo"
              />
            )}
            <span className="topbar-agency-name">{agency.name}</span>
          </div>
        )}
      </div>

      <div className="topbar-center">
        <GlobalSearch />
      </div>

      <div className="topbar-right">
        <button
          className="theme-toggle-btn"
          onClick={toggleTheme}
          aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        >
          {theme === 'light' ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          )}
        </button>
        <NotificationBell />
        <Link to="/profile" className="topbar-user-info" title="View Profile">
          <span className="topbar-user-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21c0-3.866-3.134-7-7-7h-2c-3.866 0-7 3.134-7 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
              <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.7"/>
            </svg>
          </span>
          <span className="topbar-user-name">{user?.firstName} {user?.lastName}</span>
        </Link>
        <button className="btn btn-outline btn-sm" onClick={logout}>
          Sign out
        </button>
      </div>
    </header>
  );
}
